import { MobileSettingsPage } from "@/features/tenants-settings/mobile-settings";
import { verifyRoles } from "@/utils/verifyRoles";
import { createFileRoute } from "@tanstack/react-router";
import { getTenant } from "../../../../../requests/getTenant";

export const Route = createFileRoute(
  "/dashboard/tenants/$tenantId/(settings)/mobile-settings",
)({
  component: MobileSettingsPage,
  head: () => ({
    meta: [
      {
        title:
          "Configurações de dispositivos móveis do servidor de autorização - Backoffice Detentora Iniciador",
      },
    ],
  }),
  beforeLoad: () => verifyRoles(["INIC_ADMIN", "ORG_ADMIN"]),
  loader: async ({ context, params }) => {
    await context.queryClient.prefetchQuery({
      queryKey: ["tenant", params.tenantId],
      queryFn: async () => getTenant(params.tenantId),
    });
  },
});
